/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  AdsFeedControllerGetGoogleAdsPagesExtendedFeedQueryResponse,
  AdsFeedControllerGetGoogleAdsPagesExtendedFeedPathParams,
} from '../../types/AdsFeedControllerGetGoogleAdsPagesExtendedFeed.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { adsFeedGetGoogleAdsPagesExtendedFeed } from '../../methods/adsFeedGetGoogleAdsPagesExtendedFeed.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const adsFeedGetGoogleAdsPagesExtendedFeedQueryKey = (
  wlDomain: AdsFeedControllerGetGoogleAdsPagesExtendedFeedPathParams['wlDomain'],
) => [{ url: '/api/ads-feed/:wlDomain/google-ads-pages-extended.csv', params: { wlDomain: wlDomain } }] as const;

export type AdsFeedGetGoogleAdsPagesExtendedFeedQueryKey = ReturnType<
  typeof adsFeedGetGoogleAdsPagesExtendedFeedQueryKey
>;

export function adsFeedGetGoogleAdsPagesExtendedFeedQueryOptions(
  wlDomain: AdsFeedControllerGetGoogleAdsPagesExtendedFeedPathParams['wlDomain'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = adsFeedGetGoogleAdsPagesExtendedFeedQueryKey(wlDomain);
  return queryOptions<
    AdsFeedControllerGetGoogleAdsPagesExtendedFeedQueryResponse,
    ResponseErrorConfig<Error>,
    AdsFeedControllerGetGoogleAdsPagesExtendedFeedQueryResponse,
    typeof queryKey
  >({
    enabled: !!wlDomain,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return adsFeedGetGoogleAdsPagesExtendedFeed(wlDomain, config);
    },
  });
}

/**
 * {@link /api/ads-feed/:wlDomain/google-ads-pages-extended.csv}
 */
export function useAdsFeedGetGoogleAdsPagesExtendedFeed<
  TData = AdsFeedControllerGetGoogleAdsPagesExtendedFeedQueryResponse,
  TQueryData = AdsFeedControllerGetGoogleAdsPagesExtendedFeedQueryResponse,
  TQueryKey extends QueryKey = AdsFeedGetGoogleAdsPagesExtendedFeedQueryKey,
>(
  wlDomain: AdsFeedControllerGetGoogleAdsPagesExtendedFeedPathParams['wlDomain'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        AdsFeedControllerGetGoogleAdsPagesExtendedFeedQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? adsFeedGetGoogleAdsPagesExtendedFeedQueryKey(wlDomain);

  const query = useQuery(
    {
      ...adsFeedGetGoogleAdsPagesExtendedFeedQueryOptions(wlDomain, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
